export default __webpack_public_path__ + "static/media/Icon_Class_Scientist.18c89a7b.png";